import React from 'react';
import env from '@beam-australia/react-env';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import ContentArea from 'components/layout/contentArea/contentArea';
import Header from 'components/layout/header/header';
import { getSystemManagedAlerts } from 'selectors';
import AlertContainer from './alertContainer';

const LayoutContainer = styled.div`
  font-family: ${({ theme }) => theme.fonts.baseFont};
  height: 100vh;
  margin: 0;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
`;

const Layout = (props) => {
  const showContent = env('SHOW_CONTENT') === 'true';
  const alerts = useSelector(getSystemManagedAlerts);

  return (
    <LayoutContainer>
      <AlertContainer alerts={alerts} />
      <base target="_parent" />
      <Header {...props} />
      <ContentArea
        showContent={showContent}
        {...props}
      />
    </LayoutContainer>
  );
};

export default Layout;
